import { useEffect, useState } from 'react'
import ThemeMaker from '../../../components/thememaker';
import axios from 'axios';
import { toast } from 'react-toastify';

import { NodebaseUrlDefiner } from '../../../utils/config';
import { Paginated } from '../../../components/Paginated';
import { Link } from 'react-router-dom';


export default function SellerList() {

    const [financeSellerItemList, setfinanceSellerItemList] = useState([])

    useEffect(() => {
        getfinanceSellerItemList();
    }, [])

    async function getfinanceSellerItemList() {
        try {
            let apiEndpoint = NodebaseUrlDefiner();
            const { data } = await axios({
                url: `${apiEndpoint}/adminCredit/getitems`,
                method: ""
            })

            console.log("data----------", data)

            if (data?.status === 200) {
                setfinanceSellerItemList(data?.data)
            }
        } catch (err) {
            console.log(err)
            toast.err("Error fetching sellers!")
        }


    }

    async function deleteHandler(id) {
        try {
            let apiEndpoint = NodebaseUrlDefiner();
            const { data } = await axios({
                url: `${apiEndpoint}/adminCredit/deleteprovider/${id}`,
                method: "POST"
            })

            if (data?.status === "success") {
                toast.error("Seller deleted");
                getfinanceSellerItemList();
            }
        } catch (err) {
            console.log(err)
            toast.err("Error in deleting!")
        }
    }


    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row, count) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Name",
            Footer: "Name",
            accessor: "name",
            sticky: "left"
        },
        {
            Header: "Type",
            Footer: "Type",
            accessor: "type",
            sticky: "left"
        },
        {
            Header: "Provider ID",
            Footer: "provider_id",
            accessor: "provider_id",
            sticky: "left"
        },
        {
            Header: "Interest Rate",
            Footer: "Interest Rate",
            accessor: "Interest_Rate",
            sticky: "left"
        },

        {
            Header: "Action",
            Footer: "Action",
            accessor: (row) => {

                return (
                    <div className='d-flex justify-content-center' style={{ gap: "10px" }}>
                        <Link to={`/finance/createitem/${row.id}`}>   <button className='btn btn-sm btn-success'>Edit</button></Link>
                        <button className='btn btn-sm btn-danger d-none' onClick={() => {
                            deleteHandler(row.id)
                        }} >Delete</button>
                    </div>
                )
            },
            sticky: "left"
        },

    ];

    return (
        <ThemeMaker>

            <div className="row w-100 m-0 mt-1">
                <div className="col-md-12 ">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <div className="row align-items-center">
                                <div className="col-md-6">
                                    <h6 className="m-0 font-weight-bold text-primary text-left">Item list</h6>
                                </div>
                                <div className="col-md-6 d-flex justify-content-end">
                                <Link to={`/finance/createitem`}>
                                    <button className="btn btn-sm btn-primary">Add Items</button>
                                </Link>
                                </div>
                            </div>


                        </div>

                        <div className="card-body p-0 p-1" style={{ minHeight: "70vh" }}>
                            <Paginated data={financeSellerItemList} columns={COLUMNS} />
                        </div>
                    </div>
                </div>
            </div>

        </ThemeMaker>
    )
}
